import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./style/Footer.module.css";
import TermsLink from "../Terms/TermsLink";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Footer = () => {
  const year = new Date().getFullYear();
  const [showWhatsapp, setShowWhatsapp] = useState(false);
  const footerRef = useRef(null);

  const message = encodeURIComponent(
    "Hello, I found your platform and would like help finding a tutor.",
  );

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowWhatsapp(entry.isIntersecting);
      },
      { threshold: 0.3 },
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    return () => {
      if (footerRef.current) {
        observer.unobserve(footerRef.current);
      }
    };
  }, []);

  return (
    <>
      <footer ref={footerRef} className={styles.footer}>
        <div className={styles.topSection}>
          <h1 className={styles.bigText}>Book My Tuitions</h1>

          <Link to="/signup-as-student" className={styles.ctaBtn}>
            Find Tutors
          </Link>
        </div>

        <div className={styles.footerGrid}>
          <div>
            <h4>Who We Work With</h4>
            <p>Students</p>
            <p>Private Tutors</p>
            <p>Institutions</p>
          </div>

          <div>
            <h4>Navigation</h4>
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/contactus">Contact</Link>
            <Link to="/terms" className={styles.footerLink}>
              Terms & Conditions
            </Link>
          </div>

          <div>
            <h4>Social</h4>
            <a
              href="https://www.facebook.com/profile.php?id=61575773997308"
              target="_blank"
              rel="noreferrer"
            >
              <i
                className="fab fa-facebook"
                style={{ marginRight: "8px", color: "#1877F2" }}
              ></i>
              Facebook
            </a>
            <a
              href="https://www.instagram.com/bookmytuitions/"
              target="_blank"
              rel="noreferrer"
            >
              <i
                className="fab fa-instagram"
                style={{
                  marginRight: "8px",
                  background:
                    "linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              ></i>
              Instagram
            </a>
            <a
              href="https://www.youtube.com/@BookMyTuitions"
              target="_blank"
              rel="noreferrer"
            >
              <i
                className="fab fa-youtube"
                style={{ marginRight: "8px", color: "#FF0000" }}
              ></i>
              YouTube
            </a>
          </div>

          <div>
            <h4>Contact</h4>
            <p>Info.bookmytuitions@gmail.com</p>
            <p>+91 9019027794</p>
          </div>
        </div>

        <div className={styles.copy}>
          © {year} Book My Tuitions. All Rights Reserved.
        </div>
      </footer>

      {showWhatsapp && (
        <a
          href={`https://wa.me/919019027794?text=${message}`}
          target="_blank"
          rel="noreferrer"
          className={styles.whatsappFloat}
        >
          <i className="ri-whatsapp-line"></i>
        </a>
      )}
    </>
  );
};

export default Footer;
